import { createReducer, on } from '@ngrx/store'
import * as StageActions from './stage.actions'
import { StageState } from './stage.state'

export const initialState: StageState = {
   user: undefined,
   statuses: undefined,
}

export const stageReducer = createReducer(
   initialState,
   on(StageActions.setUser, (state, action) => ({ ...state, user: action.user })),
   on(StageActions.setStatuses, (state) => ({ ...state, statuses: undefined })),
   on(StageActions.setStatusesSuccess, (state, action) => ({ ...state, statuses: action.statuses })),
   on(StageActions.setVisibilities, (state) => ({ ...state, visibilities: undefined })),
   on(StageActions.setVisibilitiesSuccess, (state, action) => ({ ...state, visibilities: action.visibilities })),
   on(StageActions.setMeasuringPurpose, (state) => ({ ...state, measuringPurpose: undefined })),
   on(StageActions.setMeasuringPurposeSuccess, (state, action) => ({ ...state, measuringPurpose: action.measuringPurpose })),
   on(StageActions.setSectors, (state) => ({ ...state, sectors: undefined })),
   on(StageActions.setSectorsSuccess, (state, action) => ({ ...state, sectors: action.sectors })),
   on(StageActions.setTechnologies, (state) => ({ ...state })),
   on(StageActions.setTechnologiesSuccess, (state, action) => ({ ...state, technologies: action.technologies })),
   on(StageActions.setCountries, (state) => ({ ...state, countries: undefined })),
   on(StageActions.setCountriesSuccess, (state, action) => ({ ...state, countries: action.countries })),
   on(StageActions.setPNOCountryResponsibles, (state) => ({ ...state })),
   on(StageActions.setPNOCountryResponsiblesSuccess, (state, action) => ({ ...state, pnoCountryResponsibles: action.pnoCountryResponsibles })),
   on(StageActions.changePassword, (state) => ({ ...state, isLoadingChangePassword: true })),
   on(StageActions.changePasswordSuccess, StageActions.changePasswordFailure, (state) => ({ ...state, isLoadingChangePassword: false })),
   on(StageActions.getAccountInfo, StageActions.updateAccountInfoSuccess, (state) => ({ ...state, accountInfo: undefined, avatar: undefined })),
   on(StageActions.getAccountInfoSuccess, (state, action) => ({ ...state, accountInfo: action.accountInfo })),
   on(StageActions.getAvatar, (state) => ({ ...state, avatar: undefined, isLoadingAvatar: true })),
   on(StageActions.getAvatarSuccess, (state, action) => ({ ...state, avatar: action.avatarFile })),
   on(StageActions.getAvatarSuccess, StageActions.getAvatarFailure, (state) => ({ ...state, isLoadingAvatar: false })),
   on(StageActions.setPathLocationPrevious, (state, action) => ({ ...state, pathLocationPrevious: action.pathLocationPrevious })),
   on(StageActions.getPNOUserNotifications, (state) => ({ ...state, isLoadingUserNotifications: true })),
   on(StageActions.getPNOUserNotificationsSuccess, (state, action) => ({
      ...state,
      userNotifications: action.userNotifications,
      isLoadingUserNotifications: false,
   })),
   on(StageActions.getPNOUserNotificationsFailure, (state) => ({ ...state, isLoadingUserNotifications: false })),
   on(StageActions.cleanNotifications, (state) => ({ ...state, userNotifications: undefined }))
)
